export type PackageName =
  | 'Basic Photo Package – 1 Hour'
  | 'Basic Video Package – 1 Hour'
  | 'Combo Package (Photo + Video)'
  | 'Custom Package';

type PackagePricingConfig = {
  basePrice?: number; // in AED
  discountPercent?: number; // 0–100
  isQuote?: boolean;
};

// Global pricing configuration per package.
// Adjust discountPercent per package here in the future.
export const PACKAGE_PRICING: Record<PackageName, PackagePricingConfig> = {
  'Basic Photo Package – 1 Hour': {
    basePrice: 900,
    discountPercent: 15
  },
  'Basic Video Package – 1 Hour': {
    basePrice: 1250,
    discountPercent: 21
  },
  'Combo Package (Photo + Video)': {
    basePrice: 1900,
    discountPercent: 20
  },
  'Custom Package': {
    isQuote: true,
    discountPercent: 0
  }
};

export const formatAED = (amount: number): string =>
  amount.toLocaleString('en-AE', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  });

// Returns the discounted price as a formatted string (without currency symbol),
// or 'Quote' for quote-based packages.
export const getDiscountedPrice = (packageName: string): string => {
  const config = PACKAGE_PRICING[packageName as PackageName];

  if (!config) {
    return 'Quote';
  }

  if (config.isQuote || config.basePrice === undefined) {
    return 'Quote';
  }

  const discount = config.discountPercent ?? 0;
  const multiplier = 1 - discount / 100;
  const discounted = Math.round(config.basePrice * multiplier);

  return formatAED(discounted);
};


